module.exports = {"421071001":"联合街道","421071002":"西湖街道","421071003":"鱼农桥街道","421071100":"滩桥镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/421071.json
// module id = 1891
// module chunks = 0